import { useGlobalStates } from "../globalConstants";
import { Brain } from 'lucide-react';

export default function SessionStatus() {
    const { sessionStatus, difficultyLevel } = useGlobalStates();

    return (
        <div className="w-full bg-white rounded-xl shadow-sm border border-gray-200 p-4">
            <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
            <Brain className="h-4 w-4 mr-2" />
                Session Status
            </h3>
            <div className="space-y-3">
            <div>
                <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                Current Interaction Stage
                </label>
                <p className="text-sm font-medium text-primary-600 mt-1 text-blue-600 mb-3">
                {sessionStatus.stage?.length > 0
                    ? sessionStatus.stage[sessionStatus.stage.length - 1]
                    : "N/A"}
                </p>

                {/* <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">EFT Skill Detected</label>
                <p className="text-sm text-gray-400 italic mb-3">
                    {sessionStatus.eft?.length > 0 &&
                    typeof sessionStatus.eft[sessionStatus.eft.length - 1]?.skill === 'string' &&
                    sessionStatus.eft[sessionStatus.eft.length - 1].skill.trim() !== '' &&
                    sessionStatus.eft[sessionStatus.eft.length - 1].skill !== 'N/A'
                        ? sessionStatus.eft[sessionStatus.eft.length - 1].skill
                        : "No EFT skill detected yet"}
                    </p>

                    <div
                    className={`text-xs flex flex-col justify-center gap-1 rounded-lg p-2 mb-2 bg-fuchsia-100 border border-fuchsia-200 text-fuchsia-700 ${
                        sessionStatus.eft?.[sessionStatus.eft.length - 1]?.name ? 'text-left' : 'text-center'
                    }`}
                    >
                        {sessionStatus.eft?.length > 0 &&
                        sessionStatus.eft[sessionStatus.eft.length - 1]?.name &&
                        sessionStatus.eft[sessionStatus.eft.length - 1]?.name !== 'N/A' && (
                            <div className="font-semibold">
                            {sessionStatus.eft[sessionStatus.eft.length - 1].name}
                            </div>
                        )}

                        {sessionStatus.eft?.length > 0 &&
                        sessionStatus.eft[sessionStatus.eft.length - 1]?.subskill &&
                        sessionStatus.eft[sessionStatus.eft.length - 1]?.subskill !== 'N/A' && (
                            <div>
                            {sessionStatus.eft[sessionStatus.eft.length - 1].subskill}
                            </div>
                        )}
                    </div> */}
                <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">Difficulty Level</label>
                <p className="text-sm font-medium mt-1 capitalize">
                    {difficultyLevel}
                </p>
            </div>
            </div>
        </div>
    )
}